import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SafetyEditPage } from './safety-edit';
import { SafetyEditComponentComponent } from '../safety-edit-component/safety-edit-component.component';
import { SharedModule } from '../../../shared/shared.module';
import { FoundationModule } from '../../../../_foundation/foundation.module';
import { DailyLogPageModule } from '../../../daily-log/daily-log/daily-log.module';
import { DirectivesModule } from '../../../../directives/directives.module';

@NgModule({
  declarations: [
    SafetyEditPage,
    SafetyEditComponentComponent,
  ],
  imports: [
    IonicPageModule.forChild(SafetyEditPage),
    SharedModule,
    FoundationModule,
    DailyLogPageModule,
    DirectivesModule,
  ],
})
export class SafetyEditPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/DPR Pages/safety/safety-edit/safety-edit.module.ts